import React from 'react'
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { AuthContext } from './Context/Auth/context';
import Welcome from '../components/Welcome'
import { useContext } from 'react';
import Layout from '../components/Layout';
import { dynamic, sidebar } from './directory';


export default function RoutesComp() {

    
    const { user } = useContext(AuthContext);

    console.log('user', user)


    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" {...(user ? { element: <Layout /> } : { element: <Welcome /> })}>
                    {user && (
                        <>
                            {Object.keys(sidebar)
                                .flatMap(el => sidebar[el])
                                .map(el => <Route
                                    key={el.code}
                                    {...el.code ? { path: el.code } : { indexed: true }}
                                    {...el.Component ? { element: <el.Component /> } : {}} />)}
                            {Object.keys(dynamic)
                                .flatMap(el => dynamic[el])
                                .map(el => <Route
                                    key={el.code}
                                    {...el.code ? { path: el.code } : { indexed: true }}
                                    {...el.Component ? { element: <el.Component /> } : {}} />)}
                            {/* <Route path="*" element={<NoMatch />} /> */}
                        </>
                    )}
                </Route>
            </Routes>
        </BrowserRouter>
    )
}
